/**
 * Hook pour transformer les données d'activité récente
 * Convertit le format API en format d'affichage
 */
export function useActivityData(activities) {
  if (!activities || !Array.isArray(activities)) {
    return [];
  }

  return activities.map(activity => {
    const typeMap = {
      'PARTICIPANT_ADDED': {
        title: `${activity.participant?.email || 'Participant'} a été ajouté`,
        description: `au sondage « ${activity.survey?.title || 'Sans titre'} »`,
        initials: activity.participant?.email?.charAt(0).toUpperCase() || 'P'
      },
      'SURVEY_CREATED': {
        title: `Sondage créé`,
        description: `« ${activity.survey?.title || 'Sans titre'} »`,
        initials: 'S'
      },
      'RESPONSE_SUBMITTED': {
        title: `Réponse soumise`,
        description: `au sondage « ${activity.survey?.title || 'Sans titre'} »`,
        initials: 'R'
      },
      'SURVEY_ARCHIVED': {
        title: `Sondage archivé`,
        description: `« ${activity.survey?.title || 'Sans titre'} »`,
        initials: 'A'
      }
    };

    const typeInfo = typeMap[activity.type] || {
      title: activity.type || 'Activité',
      description: '',
      initials: 'A'
    };

    // Formater la date
    const date = new Date(activity.created_at);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    let timestamp = 'À l\'instant';
    if (diffMins < 1) {
      timestamp = 'À l\'instant';
    } else if (diffMins < 60) {
      timestamp = `Il y a ${diffMins} min`;
    } else if (diffHours < 24) {
      timestamp = `Il y a ${diffHours}h`;
    } else if (diffDays < 7) {
      timestamp = `Il y a ${diffDays}j`;
    } else {
      timestamp = date.toLocaleDateString('fr-FR');
    }

    return {
      ...typeInfo,
      timestamp,
      type: activity.type
    };
  });
}
